import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core'
import { Params } from '@angular/router'
import { BtnClassNameType } from '../button.types'

@Component({
  selector: 'bmcore-button',
  templateUrl: './bmcore-button.component.html',
  styleUrls: ['./bmcore-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmcoreButtonComponent {
  // TODO Переделать компонент
  @Input() component: 'Button' | 'LinkAsButton' | 'LinkHref' = 'Button'

  @Input() title = ''
  @Input() routerPath = ''
  @Input() icon = ''
  @Input() disabled = false
  @Input() linkPath = ''
  @Input() mobMode = false
  // TODO: This Input prop should be renamed to variant
  @Input() styleName: BtnClassNameType
  @Input() queryParams: Params | null
  @Input() isLoader = false

  @Input() style = ''
  @Input() class = ''

  @Input() themeBtnClass: string
  @Input() themeIconClass: string

  @Output() clickHandler = new EventEmitter()

  btnClickHandler(event: MouseEvent) {
    this.clickHandler.emit(event)
  }
}
